import { initializeApp } from 'firebase/app'
import firebaseConfig from 'configs/firebase'

const app = initializeApp(firebaseConfig)

export default app
